/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone'),
        EmployeeSelectionModel = require('site/page/checkout/employee-model');


    var EmployeeSelectionCollection = Backbone.Collection.extend({
        model: EmployeeSelectionModel,

        initialize: function () {

        },

        getModels: function (modelId) {
            if (!modelId) {
                return this.toJSON();
            }

            return this.get(modelId).toJSON();
        }
    });

    return EmployeeSelectionCollection;
});
